<template>
  <div :style="styles.base" @click="handleClickEvent">
<!--    <template>-->
      <c-button ref="button" :style="computedStyle" v-bind="$props"></c-button>
<!--    </template>-->
    <!--   begin    弹框绑定手机-->
    <CTgclubGameOrderBindPhonePop  v-model="hasAccessBindPhone"
                                   v-bind="$props"
                                   :subscriptionData="subscriptionData"
                                   :configurationData="configurationData"
                                   @closeBindOrderPhone="closeBindOrderPhoneFunc"/>
    <!--   end    弹框绑定手机-->
  </div>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { componentBaseMixin } from '@tencent/ceiba-base-components';
import button from '@tencent/ceiba-act-public-button';
import CTgclubGameOrderBindPhonePop from '@tencent/ceiba-act-tgclub-game-order-bind-phone-pop';
// import CTgclubGameOrderBindPhonePop from '../tgclub-game-order-bind-phone-pop';
import CDialog from '@tencent/ceiba-base-components/src/components/base-dialog';
// import { TgclubApi } from '../ceiba-tgclub-base-components';
import { TgclubApi } from '@tencent/ceiba-tgclub-base-components';
const SUBSCRIBE_GAME_CHANNEL_XINYUE = 'xy'; // 预约游戏渠道心悦-xy 闪现-sx
const SUBSCRIBE_GAME_CHANNEL_SPARK = 'sx';
const TGCLUB = 'TGCLUB';
const SPARK = 'SPARK';
export default {
  name: 'CTgclubButtonBook',
  components: {
    [CDialog.name]: CDialog,
    [button.name]: button,
    [CTgclubGameOrderBindPhonePop.name]: CTgclubGameOrderBindPhonePop,
  },
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'tgclub-button-book-',
      // 是否已经预约
      hasGameBook: false,
      //  二次推荐内容分发
      hasAccessBindPhone: false,
      subscriptionData: {
        mobile: '', // 已经预约的手机
        isFocusOn: false, // 是否关注公众号
        switchStatus: 1, // 短信通知状态
        gid: 0,
        nickname: '',
      },
    };
  },
  computed: {
    computedStyle() {
      const { bookImage, bookDoneImage } = this.configurationData;
      return {
        cursor: 'pointer',
        position: 'static',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% 100%',
        backgroundImage: `url(${this.hasGameBook === false ? bookImage :  bookDoneImage})`,
      };
    },
    // 预约游戏渠道
    subscribeGameChannel() {
      let astName = TGCLUB;
      if (this.$ast.currentAstName) {
        astName = this.$ast.currentAstName();
      }
      if (astName === TGCLUB) {
        return SUBSCRIBE_GAME_CHANNEL_XINYUE;
      }
      if (astName === SPARK) {
        return SUBSCRIBE_GAME_CHANNEL_SPARK;
      }
      return SUBSCRIBE_GAME_CHANNEL_XINYUE;
    },
  },
  mounted() {
    console.log('configurationData= tgclub book game ', this.configurationData);
    console.log(' styles tgclub book', this.styles);
    this.initialize();
  },
  methods: {
    initialize() {
      if (this.$isInEditor) return;
      this.initGameBookStatus();
      this.asyncGameBookStatus();
    },
    async initGameBookStatus() {
      // 新增端游预约
      const {  gid, autoBook = false, mustAppBook = true, extraGameCheckBookFlow = 0   } = this.configurationData;
      this.$onLogined(async () => {
        let res = false;
        if (extraGameCheckBookFlow > 0) {
          const response = await this.flowRequest({
            flowId: extraGameCheckBookFlow,
          });
          console.log('extraGameCheckBookFlow  response = ', response);
          const { ret = 0, data = {}  } = response || {};
          const { ret: resRet  = 0 } = data;
          res = (ret === 0  &&  resRet === 0);
        } else  {
          res = await  TgclubApi.queryUserSubscription(parseInt(gid, 10));
        }
        if (res === false) {
          this.hasGameBook = false;
          if (autoBook) {
            // 在app 内自动预约
            if (mustAppBook && this.isApp) {
              this.doGameBook();
            }
            // H5 自动预约
            if (!mustAppBook) {
              this.doGameBook();
            }
          }
        } else if (res === true) {
          this.hasGameBook = true;
        }
      });
      this.$refs.button.setClickHandler(this.doGameBook, {
        forceApp: this.configurationData.mustAppBook,
        forceLogin: true,
        forceRole: false,
      });
    },
    // 获取预约
    async doGameBook() {
      const { bookFlowId } = this.configurationData;
      if (this.hasGameBook === true) return;
      const response = await this.flowRequest({
        flowId: bookFlowId,
        params: {
          data: JSON.stringify({
            subscribe_game_channel: this.subscribeGameChannel,
          }),
        },
      });
      const { ret, msg, data = {} } = response || {};
      console.log('do book action response ', response);

      if (ret !== 0) {
        this.reportFunc('0', false);
        return  this.$alert({ msg });
      }
      const { ret: resRet, msg: resMsg } = data;
      if (resRet !== 0) {
        this.reportFunc('0', false);
        return  this.$alert({  msg: resMsg  || '预约失败' });
      }
      this.hasGameBook = true;
      this.callBack();  //  预约后回调
      // switchStatus 0 打开 1 关闭
      const { mobile = '', is_focus_on: isFocusOn = false, switch_status: switchStatus = 0  } = data;
      this.subscriptionData = {
        mobile,
        isFocusOn: !!isFocusOn,
        switchStatus,
        gid: this.configurationData.gid,
        nickname: this.userInfo?.nickName ?? '',
      };
      this.hasAccessDistributionContent = true;
      this.hasAccessBindPhone = true;
      this.broadcastGameBookResult(true);
      return false;
    },
    // 预约回调
    async callBack() {
      const { callBackFlowId = 0, successCallBackMsg = '', showSuccessCallBackError = false } = this.configurationData;
      console.log('run  game book callback and callBackFlowId = ', callBackFlowId);

      if (callBackFlowId > 0) {
        const response = await this.flowRequest({
          flowId: callBackFlowId,
          params: {
            role: this.roleInfo,
          },
        });
        this.refreshQua(); // 刷新礼包
        console.log('  game book callback  response = ', response);

        const { ret, msg = '', data = {} } = response;
        const { ret: resRet = 0, msg: resMsg =  '' } = data;
        if (ret === 0 && resRet === 0) {
          if (successCallBackMsg) {
            this.$alert({ msg: successCallBackMsg });
            return  true;
          }
        }
        if (showSuccessCallBackError === true) {
          this.$alert({ msg: msg ||  resMsg });
          return  true;
        }
      }
    },
    accessBindPhone() {
      const { inputPhoneFlowId = 0 } = this.configurationData;
      if (inputPhoneFlowId <= 0)  return;
      this.hasAccessDistributionContent = true;
    },
    closeBindOrderPhoneFunc(silentlyDownRes) {
      console.log('silentlyDownRes book = ', !!silentlyDownRes);
      this.hasAccessDistributionContent = false;
      this.hasAccessBindPhone = false;
      this.reportFunc('1', !!silentlyDownRes);
    },

    asyncGameBookStatus() {
      const { gid: targetGid  } = this.configurationData;
      this.$eventBus.$on('ceiba:custom:events:game:book:result', async ({ status, gid }) => {
        if (status && targetGid && gid ===  targetGid) {
          this.hasGameBook = true;
        }
      });
    },
    //  存在多个预约地方的时候  同步
    broadcastGameBookResult(val) {
      const { gid } = this.configurationData;
      this.$eventBus.$emit('ceiba:custom:events:game:book:result', { status: val, gid  });
    },
    reportFunc(status, silentlyDown) {
      //  埋点上报
      if (typeof  this.reportClickRaw === 'function') {
        const params = {
          ceibaComponentId: `${this.cid}`,
          ceibaComponentUid: this.uid,
          ceibaComponentUname: this.uname,
          eventKey: 'order',
          eventData: { status,  game_code: this.$actInfo?.game_code ?? '', silently_down: silentlyDown ? '1' : '0' },
        };
        this.reportClickRaw(params);
        console.log('reportFunc bind Phone in order  data =', params);
      }
    },
  },
};
</script>
<style lang="scss">
@import './styles.scss';
</style>
